import gql from 'graphql-tag';

export const GET_BACKOFFICE_LINK = gql`
  query selfGenerateBackOfficeLink($memberId: String!) {
    selfGenerateBackOfficeLink(memberId: $memberId) {
      url
    }
  }
`;
